import RequestSharedView from '../data/request'

export default class ApiSharedViewSession {

    private publicKey!: string

    setPublicKey(value: string) {
        this.publicKey = value;
    }

    getMissingData(dataToLoad: any) {
        // @ts-ignore
        return new RequestSharedView(this,'POST',this.publicKey+'/session',dataToLoad);
    }

    resetMissing(params: any) {
        // @ts-ignore
        return new RequestSharedView(this, 'POST', this.publicKey+'/session/reset-missing', params);
    }

    loadOlderCompanyAndPersonalEvents(companyId: ID, startMoment: Moment, endMoment: Moment) {
        // @ts-ignore
        return new RequestSharedView(this, 'GET', this.publicKey+'session/events', {
            startDate   : startMoment.format('YYYY-MM-DD'),
            endDate     : endMoment.format('YYYY-MM-DD'),
        })
    }
}